import { useReducedMotion } from "framer-motion";

/**
 * Sistema de micro-interacciones de SEBBIA.
 *
 * Centraliza la "sensación física" de cada interacción para que todo el
 * producto (login, dashboard, módulos) se sienta igual. Los componentes
 * (`Tappable`, `MotionButton`) consumen estos presets en vez de definir
 * animaciones ad-hoc por pantalla.
 *
 * Anti-patrón a evitar (CLAUDE.md): nunca `transition: all` en contenedores.
 * Aquí solo animamos `transform` (scale) → barato y fluido en GPU.
 */

// Cuánto se "hunde" un elemento al presionarlo (active state tipo iOS).
export const tapScale = 0.96;

// Spring suave para apariciones/cambios de estado no táctiles (modals, listas).
export const springSoft = { type: "spring", stiffness: 260, damping: 24, mass: 1 };

// Spring que le da "peso" a cada toque (el feel iPhone) — el corazón del sistema.
// Calibrado para una respuesta ~30% más rápida que el preset inicial, conservando
// el mismo rebote (damping ratio ζ ≈ 0.43). Velocidad del click ≈ 0.70 del original.
//   - stiffness 860 → hundido muy inmediato/snappy al presionar
//   - damping   24  → mismo overshoot orgánico que antes (subí para asentar plano,
//                     bajá para más rebote)
//   - mass     0.9  → un toque ligero/premium; subilo para sentirlo más pesado
// Regla: si cambiás stiffness o mass, recalculá ζ = damping / (2·√(stiffness·mass))
// para mantener el rebote donde te gusta.
export const springTap = { type: "spring", stiffness: 860, damping: 24, mass: 0.9 };

/**
 * Hook que devuelve las props de animación de "tap" listas para un componente
 * `motion.*`, respetando `prefers-reduced-motion` (accesibilidad).
 * Si el usuario pidió menos movimiento, devuelve {} (sin animación).
 */
export function useTapAnimation(scale = tapScale) {
  const prefersReducedMotion = useReducedMotion();
  if (prefersReducedMotion) return {};
  return {
    whileTap: { scale },
    transition: springTap,
  };
}
